// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"445":"1a098b9c52b3037b99f7","532":"ef3b7d4ec13f3a025ce3","678":"fa107a69b9ae375cf9bb"}[chunkId] + ".js";
};